export default {
    namespaced: true,

    state: {
        payroll_start_date: '',
        payroll_end_date: '',
        payroll_pay_period_id: '',
        payroll_pay_period_cycle_id: '',
        // Computed-period selection (frontend-02 / list-01): the explicit period
        // dates submitted for a non-enforced tenant. Empty for a shared cycle id.
        from_date: '',
        thru_date: '',
    },

    mutations: {
        setPayrollStartDate(state, data) {
            state.payroll_start_date = data;
        },

        setPayrollEndDate(state, data) {
            state.payroll_end_date = data;
        },

        setPayrollPayPeriod(state, data) {
            state.payroll_pay_period_id = data;
        },

        setPayrollPayPeriodCycle(state, data) {
            state.payroll_pay_period_cycle_id = data;
        },

        setFromDate(state, data) {
            state.from_date = data;
        },

        setThruDate(state, data) {
            state.thru_date = data;
        },

        reset(state) {
            state.payroll_start_date = '';
            state.payroll_pay_period_id = '';
            state.payroll_pay_period_cycle_id = '';
            state.from_date = '';
            state.thru_date = '';
        },
    },
};
